//ConfirmNavigationModal.js
import React from 'react'
import { CButton, CToast, CToastBody } from '@coreui/react'
import PropTypes from 'prop-types'
import { useNavConfirmation } from './NavConfirmationContext'

const ConfirmNavigationModal = ({ onConfirm, onCancel, onSaveAndLeave, isSavingBeforeLeaving }) => {
  //Show confirmation modal on exit
  const { saveFunction } = useNavConfirmation()
  return (
    <>
      <div className="spinner-container">
        <div className="spinner-content align-left">
          <CToast
            animation={true}
            autohide={false}
            visible={true}
            className="holcim-toast holcim-toast-notification-progress holcim-toast-medium danger"
          >
            <div>
              {/*<CToastHeader className="toastHeaderClose" closeButton={false} />*/}
              <CToastBody>
                {!isSavingBeforeLeaving ? (
                  <>
                    <p>You have unsaved changes. Are you sure you want to leave?</p>
                    {saveFunction && (
                      <>
                        <CButton
                          className="mt-2 holcim-light-gray-not-bg-btn btn-soft-radius"
                          onClick={onSaveAndLeave}
                        >
                          Save changes and leave
                        </CButton>{' '}
                      </>
                    )}
                    <CButton
                      className="mt-2 holcim-light-gray-not-bg-btn btn-soft-radius"
                      onClick={onConfirm}
                    >
                      Discard changes
                    </CButton>{' '}
                    <CButton
                      className="mt-2 holcim-light-gray-not-bg-btn btn-soft-radius"
                      onClick={onCancel}
                    >
                      Return to edit
                    </CButton>
                  </>
                ) : (
                  <p>Saving changes, please wait...</p>
                )}
              </CToastBody>
            </div>
          </CToast>
        </div>
      </div>
    </>
  )
}
ConfirmNavigationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSaveAndLeave: PropTypes.func.isRequired,
  isSavingBeforeLeaving: PropTypes.bool.isRequired,
}

export default ConfirmNavigationModal
